"use client";

/**
 * Brand text component for NotreImmeuble
 * Displays "Notre" in solid color and "Immeuble" with gradient
 * Updated for visual alignment and impact
 */
export function BrandText({
  className = "",
  size = "default",
}: {
  className?: string;
  size?: "sm" | "default" | "lg" | "xl";
}) {
  const sizeClasses = {
    sm: "text-base font-bold tracking-[-0.05em]",
    default: "text-xl font-extrabold tracking-[-0.05em]",
    lg: "text-2xl font-extrabold tracking-[-0.05em]",
    xl: "text-3xl font-extrabold tracking-[-0.05em]",
  };

  return (
    <span className={`${sizeClasses[size]} ${className} font-sans`}>
      {/* "Notre" changes color based on theme */}
      <span className="text-slate-900 transition-colors duration-200 dark:text-white">
        Notre
      </span>
      {/* "Immeuble" with explicit inline styles for robust gradient support */}
      <span
        style={{
          // Gradient unified defined in globals.css (adapts to light/dark mode)
          backgroundImage: "var(--brand-text-gradient)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
          WebkitTextFillColor: "transparent", // Safari/Chrome support fallback
          display: "inline-block",
          paddingBottom: "2px", // Prevent descenders clipping
          marginLeft: "2px", // ml-0.5
          backgroundSize: "200% auto",
        }}
        className="animate-gradient-x"
      >
        Immeuble
      </span>
    </span>
  );
}
